//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'AcaoFluxo',
  props: {
    corIcone: {
      type: String,
      default: null,
    },
    icone: {
      type: String,
      default: '',
    },
    disabled: false,
    exibirJustificativa: false,
    pendencia: null,
    status: {
      type: String,
      default: '',
    },
    ultimaPagina: false,
    validarJustificativa: false,
    textoAcao: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    menu: false,
    valid: false,
    bloquearCampos: false,
    exibirPerguntaProximo: false,
  }),
  watch: {
    menu(val) {
      if (val) {
        setTimeout(() => this.$refs.textareaJustificativa.focus(), 5E2);
      }
    },
    disabled(val) {
      if (!val) {
        this.desbloquearCampos();
        this.exibirPerguntaProximo = false;
        this.$forceUpdate();
      }
    },
  },
  methods: {
    required(v) {
      return !this.validarJustificativa || !!v || this.$t('label.campo_obrigatorio');
    },
    cancelar() {
      this.pendencia.justificativa = '';
      this.fechar();
    },
    fechar() {
      this.menu = false;
    },
    naoIrProximo() {
      this.fechar();
      this.$emit('AcaoFluxo_executarAcao', false);
    },
    irProximo() {
      this.fechar();
      this.$emit('AcaoFluxo_executarAcao', true);
    },
    acaoExecutada() {
      this.exibirPerguntaProximo = true;
    },
    desbloquearCampos() {
      this.bloquearCampos = false;
    },
    executarAcao() {
      if (this.bloqueioSistema) {
        this.mostrarMensagemBloqueio();
        return;
      }
      if (!this.$refs.form.validate()) return;
      this.bloquearCampos = true;
      if (!this.ultimaPagina) {
        this.acaoExecutada();
      } else {
        this.naoIrProximo();
      }
    },
    getStatus(status) {
      return {
        APROVADO: this.$tc('status_entidade.aprovado', 1),
        AGUARDANDO_APROVACAO: this.$tc('status_entidade.aprovado', 1),
        EM_ANALISE: this.$tc('status_entidade.em_analise', 1),
        REPROVADO: this.$tc('status_entidade.reprovado', 1),
      }[status];
    },
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/dashboard/cadeia/apuracao/pendencias/AcaoFluxo.vue?vue&type=script&lang=js&